import { render, staticRenderFns } from "./SelectImagesModal.vue?vue&type=template&id=5b98808f&scoped=true"
import script from "./SelectImagesModal.vue?vue&type=script&lang=ts"
export * from "./SelectImagesModal.vue?vue&type=script&lang=ts"
import style0 from "./SelectImagesModal.vue?vue&type=style&index=0&id=5b98808f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b98808f",
  null
  
)

export default component.exports